import React from "react";

const NoMatch: React.FC = props => <h1>404</h1>;

export default NoMatch;
